<template>
    <div class="no-data">
        <span v-if="image" class="image"></span>
        <b>{{ title }}</b>
        <p>{{ text }}</p>
        <div class="btns m-t-6">
            <slot name="btns"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
.no-data {
    text-align: center;
    font-size: 24px;
    color: $-text-950;
    line-height: 24px;
    font-weight: bold;
    margin-top: 40px;

    b {
        display: block;
        margin-top: 30px;
    }

    .image {
        background: url('~@/assets/img/album/up@2x.png') center no-repeat;
        background-size: cover;
        width: 200px;
        height: 190px;
        display: inline-block;
    }

    p {
        margin-top: 16px;
        color: $-text-600;
        font-size: 14px;
        font-weight: normal;
    }
}
</style>